(() => {
  const storageKey = 'veyea-wardrobe-decks-v1';
  let decks = {};
  try { decks = JSON.parse(localStorage.getItem(storageKey) || '{}') || {}; } catch (_) {}
  const shuffle = items => {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    return items;
  };
  const next = (identity, count = 7) => {
    const saved = decks[identity];
    const valid = saved && Number.isInteger(saved.last) && Array.isArray(saved.remaining) && saved.remaining.every(n => Number.isInteger(n) && n >= 0 && n < count) && new Set(saved.remaining).size === saved.remaining.length;
    const deck = valid ? saved : { last: -1, remaining: [] };
    if (!deck.remaining.length) {
      deck.remaining = shuffle(Array.from({ length: count }, (_, i) => i));
      if (count > 1 && deck.remaining[0] === deck.last) {
        const swap = 1 + Math.floor(Math.random() * (count - 1));
        [deck.remaining[0], deck.remaining[swap]] = [deck.remaining[swap], deck.remaining[0]];
      }
    }
    deck.last = deck.remaining.shift();
    decks[identity] = deck;
    try { localStorage.setItem(storageKey, JSON.stringify(decks)); } catch (_) {}
    return deck.last;
  };
  const asset = (manifest, model, hairStyle, outfit) => {
    const entry = manifest?.[model]?.[hairStyle];
    if (!entry || !Number.isInteger(outfit) || outfit < 0 || outfit > 6) return null;
    if (typeof entry === 'string') return { url: entry, columns: 8, rows: 7, row: outfit };
    const selected = Array.isArray(entry) ? entry[outfit] : entry;
    if (selected?.url && selected.columns && selected.rows) return { url: selected.url, columns: selected.columns, rows: selected.rows };
    const row = selected?.row ?? outfit;
    if (selected?.url && selected.bounds?.length > row + 1) {
      const top = (selected.bounds[row] + 1) / selected.height;
      const height = (selected.bounds[row + 1] - selected.bounds[row] - 2) / selected.height;
      return { url: selected.url, columns: 8, rows: selected.bounds.length - 1, row, top, height };
    }
    const url = entry[outfit];
    return typeof url === 'string' ? { url, columns: 4, rows: 2 } : null;
  };
  const paintFrame = (image, asset, frame) => {
    image.style.width = `${asset.columns * 100}%`;
    image.style.height = `${asset.height ? 100 / asset.height : asset.rows * 100}%`;
    const column = frame % asset.columns;
    const row = asset.row ?? Math.floor(frame / asset.columns);
    image.style.transform = `translate(${-100 * column / asset.columns}%, ${asset.top !== undefined ? -100 * asset.top : -100 * row / asset.rows}%)`;
  };
  window.VeyeaWardrobe = { next, asset, paintFrame };
  window.dispatchEvent(new Event('veyea:wardrobe-ready'));
})();

